import { api } from "@/lib/api";

const IDLE_MS = 10 * 60 * 1000;
const KEY = "abcd_chat_token";
let lastActivity = Date.now();
let lastRefresh = 0;

export const getChatToken = () => {
  const t = sessionStorage.getItem(KEY);
  if (t && Date.now() - lastActivity > IDLE_MS) { clearChatToken(); return null; }
  return t;
};
export const setChatToken = (t) => { sessionStorage.setItem(KEY, t); lastActivity = Date.now(); lastRefresh = Date.now(); window.dispatchEvent(new Event("chat-unlocked")); };
export const clearChatToken = () => { sessionStorage.removeItem(KEY); window.dispatchEvent(new Event("chat-locked")); };

export function touchChat() {
  if (!sessionStorage.getItem(KEY)) return;
  if (Date.now() - lastActivity > IDLE_MS) { clearChatToken(); return; }
  lastActivity = Date.now();
  if (Date.now() - lastRefresh > 60000) {
    lastRefresh = Date.now();
    chatApi("post", "/chat/pin/refresh").then((r) => sessionStorage.setItem(KEY, r.data.chat_token)).catch(() => {});
  }
}

export async function chatApi(method, url, data, cfg = {}) {
  const token = getChatToken();
  if (!token) { const e = new Error("Chat is locked"); e.locked = true; throw e; }
  try {
    return await api.request({ method, url, data, ...cfg, headers: { ...(cfg.headers || {}), "X-Chat-Token": token } });
  } catch (e) {
    if (e?.response?.status === 423) clearChatToken();
    throw e;
  }
}

setInterval(() => { if (sessionStorage.getItem(KEY) && Date.now() - lastActivity > IDLE_MS) clearChatToken(); }, 15000);
["mousemove", "keydown", "click", "touchstart", "scroll"].forEach((ev) => window.addEventListener(ev, () => touchChat(), { passive: true, capture: true }));

export function playChatSound() {
  if (localStorage.getItem("abcd_chat_muted") === "1") return;
  try {
    const ctx = new (window.AudioContext || window.webkitAudioContext)();
    const o = ctx.createOscillator(); const g = ctx.createGain();
    o.type = "sine"; o.frequency.setValueAtTime(880, ctx.currentTime); o.frequency.setValueAtTime(1320, ctx.currentTime + 0.09);
    g.gain.setValueAtTime(0.12, ctx.currentTime); g.gain.exponentialRampToValueAtTime(0.001, ctx.currentTime + 0.3);
    o.connect(g); g.connect(ctx.destination); o.start(); o.stop(ctx.currentTime + 0.3);
  } catch (e) { /* audio blocked */ }
}
